<mat-dialog-content>
    <div class="hypo-dialog-header">
        <div class="hypo-dialog-title">
            <mat-icon>group</mat-icon>
            <div>
                Úprava domácnosti
                @if (index) {
                    <span> (<span class="hidden md:inline">Domácnost </span>č. {{ index + 1 }}) </span>
                }
            </div>
        </div>

        <button mat-dialog-close type="button" [attr.data-testid]="'household-dialog-button-close'">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    @if (showContent) {
        <div class="hypo-dialog-content">
            <div class="flex flex-col gap-4">
                <form [formGroup]="householdForm" fxLayout="column" appHasError #hasError="appHasError">
                    <app-hypo-radio
                        [label]="'Typ domácnosti'"
                        [listName]="'householdType'"
                        [toggleAbleOptions]="true"
                        [itemClass]="'max-md:w-full'"
                        formControlName="type">
                    </app-hypo-radio>
                    <div class="household-members">
                        <div class="household-members-title">Členové domácnosti</div>
                        <div class="flex flex-row gap-5">
                            @for (applicant of applicants; track applicant; let i = $index) {
                                <mat-checkbox
                                    #checkbox
                                    (change)="applicantCheckboxChange($event, applicant)"
                                    [attr.data-testid]="'household-dialog-checkbox-member:' + i"
                                    [checked]="applicantIsChecked(applicant)"
                                    [disabled]="
                                        !checkbox.checked &&
                                        householdForm.get('applicants').value.length >= MAX_APPLICANTS_PER_HOUSEHOLD
                                    "
                                    class="success">
                                    {{ applicant._id | contactName: applicants }}
                                </mat-checkbox>
                            }
                        </div>
                    </div>
                    <div formArrayName="members" class="flex flex-col">
                        <button
                            (click)="addMember()"
                            [attr.data-testid]="'household-dialog-button-add-member'"
                            class="ui-add-panel calculator-additional-household-dialog-member-button"
                            mat-button
                            type="button">
                            <div class="flex flex-row items-center justify-center gap-2">
                                <mat-icon>add_circle_outline</mat-icon>
                                <span
                                    >Přidat {{ householdMembers['controls']?.length ? 'dalšího' : '' }} člena
                                    domácnosti</span
                                >
                            </div>
                        </button>
                        <div class="members-container flex flex-col gap-5">
                            @for (member of householdMembers.controls; track member; let hmIndex = $index) {
                                <div
                                    class="member-item max-md:border-gray-400 max-md:py-2 max-md:px-4 max-md:border rounded-md">
                                    <div
                                        [formGroupName]="hmIndex"
                                        [attr.data-testid]="'household-dialog-member:' + hmIndex"
                                        class="flex flex-row flex-wrap items-center justify-between">
                                        <app-hypo-radio
                                            [label]="'Typ člena'"
                                            [listName]="'memberType'"
                                            formControlName="type"
                                            [itemClass]="'max-sm:w-full'"
                                            class="max-md:w-full">
                                        </app-hypo-radio>
                                        <app-hypo-input
                                            [inputmode]="'decimal'"
                                            [label]="'Věk člena'"
                                            [mask]="'00'"
                                            [step]="1"
                                            [suffix]="member.get('age').value | years: true"
                                            formControlName="age"
                                            class="w-full md:w-5/12">
                                        </app-hypo-input>
                                        <button
                                            (click)="removeMember(member, hmIndex)"
                                            class="btn-xxs transparent button-remove primary noborder flex-none w-full md:w-auto"
                                            [attr.data-testid]="'household-dialog-button-remove-member:' + hmIndex"
                                            mat-button
                                            type="button">
                                            <div class="flex flex-row gap-1 items-center justify-center">
                                                <mat-icon>highlight_off</mat-icon>
                                                <span>Odstranit</span>
                                            </div>
                                        </button>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </form>
                @if (isSent) {
                    @if (!householdHasAnyApplicant) {
                        <app-info-panel>
                            <div class="panel-title">Domácnost musí mít alespoň jednoho člena z řad Žadatelů</div>
                        </app-info-panel>
                    }
                    @if (applicantAloneMarried) {
                        <app-info-panel>
                            <div class="panel-title">
                                Pokud je v Domácnosti pouze jeden člen z řad Žadatelů, tento Žadatel nesmí mít rodinný
                                stav Vdaná/ženatý
                            </div>
                        </app-info-panel>
                    }
                    @if (applicantAloneRegistered) {
                        <app-info-panel>
                            <div class="panel-title">
                                Pokud je v Domácnosti pouze jeden člen z řad Žadatelů, tento Žadatel nesmí mít rodinný
                                stav Registrovaný/á partner/ka
                            </div>
                        </app-info-panel>
                    }
                }
                @if (hasError.invalid) {
                    <app-info-panel>
                        <div class="panel-title">Prosím, vyplňte správně všechny povinné údaje.</div>
                    </app-info-panel>
                }
            </div>
        </div>
    }

    <div class="hypo-dialog-footer">
        <button
            (click)="continue()"
            class="btn btn-lg orange household-dialog-button-continue"
            mat-button
            type="button"
            [attr.data-testid]="'household-dialog-button-continue'">
            Pokračovat
        </button>
    </div>
</mat-dialog-content>
